import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=d9cfe6e0&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=d9cfe6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cfe6e0",
  null
  
)

export default component.exports